// CHANGED THE DEPENDENCY FROM ENTIRE USERDETAILS OBJECT TO ID.

import { useMemo } from 'react';
import { Message } from './useMessages';

export type MessageFinalStatus = 'pending' | 'failed' | 'sent';

export interface MessageStatuses {
  seenMessageId: string | null;
  lastSentIfFinalFailed: string | null; 
  finalStatus: {
    messageId: string;
    status: MessageFinalStatus;
  } | null;
}

export const useMessageStatuses = (
  messages: Message[],
  currentUserId?: string
): MessageStatuses => {
  return useMemo(() => {
    const result: MessageStatuses = { seenMessageId: null, finalStatus: null, lastSentIfFinalFailed: null };

    if (!messages || !currentUserId) return result;

    // 1. Last message of mine that has been read
    const myReadMessages = messages.filter(
      msg => msg.senderId === currentUserId && msg.readAt
    );

    const lastSeenMessage =
      myReadMessages.length > 0
        ? myReadMessages.reduce((latest, current) =>
            new Date(latest.created_at) > new Date(current.created_at) ? latest : current
          )
        : null;

    if (lastSeenMessage) {
      result.seenMessageId = lastSeenMessage.id;
    }

    // 2. Last message I sent (for pending/failed/sent)
    const lastSentMessage = messages
      .slice()
      .reverse()
      .find(msg => msg.senderId === currentUserId);

    if (lastSentMessage && lastSentMessage.id !== result.seenMessageId) {
      let status: MessageFinalStatus = 'sent';
      if (lastSentMessage.status === 'pending') status = 'pending';
      if (lastSentMessage.status === 'failed') status = 'failed';

      result.finalStatus = {
        messageId: lastSentMessage.id,
        status,
      };
    }

    if (result.finalStatus?.status === 'failed') {
      const previousValidMessage = messages
        .slice()
        .reverse()
        .find(
          msg => 
            msg.senderId === currentUserId &&
            msg.status !== 'failed' && 
            msg.status !== 'pending' &&
            msg.id !== result.finalStatus!.messageId
        );

        if (previousValidMessage && previousValidMessage.id !== result.seenMessageId) {
          result.lastSentIfFinalFailed = previousValidMessage.id;
        }

    }

    return result;
  }, [messages, currentUserId]);
};
